import { SideNav, useScopedSelector } from 'ia-react-core';
import React from 'react';
import { Product } from 'omni-package-react-core';
import { SideNavGroupeInsurance } from 'we-package-react-group-insurance';
import { MyProductsResourceInfo } from '../components/MyProductsResource/MyProductsResource';

const useProductsNavLinks = () => {
  let products: Product[] = useScopedSelector(MyProductsResourceInfo.dataDst) || [];
  products = products.filter((p) => p.isClickable);
  return Array.from(products.map((product: Product) => (
    product.ownerCode === 'AC' && !product.uniqueLinkText ?
      <SideNavGroupeInsurance product={product} />
      :
      <SideNav.Link id={product.id} key={product.id} to={product.browsingValue} external>{product.description}</SideNav.Link>
  )));
};

export default useProductsNavLinks;
